
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perfect-synergies",
      function () {
        return require("private-next-pages/perfect-synergies.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perfect-synergies"])
      });
    }
  